// extracted by mini-css-extract-plugin
module.exports = {"translationSwitcher":"TranslationSwitcher_translationSwitcher__1WpvB","TranslationDialogOptionFlag":"TranslationSwitcher_TranslationDialogOptionFlag__2otAW"};